import src from "./bg-mobile-rebrand.jpg";
export default { src: src, aspect: 1.3, width: 832, height: 640 };